import { TFunction } from "i18next";
import { Control } from "react-hook-form";

import { ControlledSelect } from "@/components/shared/ControlledSelect";

import { StyledInputContainer, StyledSection } from "../styles";
import { GetCreationTemplateFormType } from "../types";

type LedgerTypeSelectorProps = {
  control: Control<GetCreationTemplateFormType>;
  ledgerTypeOptions: { value: string; label: string }[];
  tFormData: TFunction<"formData">;
  onSelectLedgerType: () => void;
};

export const LedgerTypeSelector = ({
  control,
  ledgerTypeOptions,
  tFormData,
  onSelectLedgerType,
}: LedgerTypeSelectorProps) => (
  <StyledSection>
    <StyledInputContainer>
      <ControlledSelect
        control={control}
        name='ledgerTypeId'
        namespace='formData'
        selectProps={{
          type: "options",
          options: ledgerTypeOptions,
          label: tFormData("formData.creationTemplate.ledgerTypeSelector"),
          dataTestId: "formdata__create-template-form_ledgerTypeId-select",
          className: "select-ledger-type",
          onChange: () => {
            onSelectLedgerType();
          },
        }}
      />
    </StyledInputContainer>
  </StyledSection>
);
